<template>
  <div class="finn-home-page">
    <nav-header :title="title"></nav-header>
    <main class="finn-home-content">
      <section class="finn-intro-card">
        <div class="finn-intro-icon" aria-hidden="true">
          <i class="material-icons">park</i>
        </div>
        <div class="finn-intro-copy">
          <span class="finn-kicker">Fugle i Ny Natur</span>
          <h1>
            {{ $englishPreferred ? "Welcome to FiNN" : "Velkommen til FiNN" }}
          </h1>
          <p>
            {{
              $englishPreferred
                ? "Learn about the project before making your first FiNN count."
                : "Læs om projektet, inden du laver din første FiNN-tælling."
            }}
          </p>
          <a
            href="https://www.dof.dk/naturbeskyttelse/projekter/fugle-i-ny-natur-finn"
            target="_blank"
            rel="noopener noreferrer"
            class="finn-project-link"
          >
            <span>{{
              $englishPreferred ? "About the project" : "Om projektet"
            }}</span>
            <i class="material-icons" aria-hidden="true">open_in_new</i>
          </a>
        </div>
        <span class="finn-support-badge">
          {{ $englishPreferred ? "Supported by AVJF" : "Støttet af AVJF" }}
        </span>
      </section>

      <nav
        class="finn-menu"
        :aria-label="$englishPreferred ? 'FiNN menu' : 'FiNN-menu'"
      >
        <button
          type="button"
          class="finn-menu-button is-primary"
          @click="directToNewCount()"
        >
          <span class="finn-menu-icon" aria-hidden="true">
            <i class="material-icons">play_arrow</i>
          </span>
          <span class="finn-menu-label">
            {{ $englishPreferred ? "Start FiNN count" : "Start FiNN-tælling" }}
          </span>
          <i class="material-icons finn-menu-arrow" aria-hidden="true"
            >chevron_right</i
          >
        </button>

        <button
          type="button"
          class="finn-menu-button"
          @click="directToCompletedCount()"
        >
          <span class="finn-menu-icon" aria-hidden="true">
            <i class="material-icons">edit_calendar</i>
          </span>
          <span class="finn-menu-label">
            {{
              $englishPreferred
                ? "Add completed FiNN count"
                : "Indtast gennemført FiNN-tælling"
            }}
          </span>
          <i class="material-icons finn-menu-arrow" aria-hidden="true"
            >chevron_right</i
          >
        </button>

        <router-link to="/vejledning" class="finn-menu-button is-primary">
          <span class="finn-menu-icon" aria-hidden="true">
            <i class="material-icons">help_outline</i>
          </span>
          <span class="finn-menu-label">
            {{
              $englishPreferred
                ? "FiNN count guide"
                : "Vejledning i FiNN-tælling"
            }}
          </span>
          <i class="material-icons finn-menu-arrow" aria-hidden="true"
            >chevron_right</i
          >
        </router-link>

        <router-link to="/finn/kort" class="finn-menu-button">
          <span class="finn-menu-icon" aria-hidden="true">
            <i class="material-icons">map</i>
          </span>
          <span class="finn-menu-label">
            {{ $englishPreferred ? "FiNN map" : "FiNN-kortet" }}
          </span>
          <i class="material-icons finn-menu-arrow" aria-hidden="true"
            >chevron_right</i
          >
        </router-link>

        <router-link to="/finn/statistik" class="finn-menu-button is-primary">
          <span class="finn-menu-icon" aria-hidden="true">
            <i class="material-icons">analytics</i>
          </span>
          <span class="finn-menu-label">
            {{ $englishPreferred ? "FiNN statistics" : "FiNN-statistik" }}
          </span>
          <i class="material-icons finn-menu-arrow" aria-hidden="true"
            >chevron_right</i
          >
        </router-link>
      </nav>
    </main>
  </div>
</template>

<script>
/* global $cookies */
import NavHeader from "@/components/navbars/NavHeader.vue";
import siteRepository from "../idb/repositories/siteRepository";
import specieRepository from "../idb/repositories/specieRepository";
import primaryBehaviourRepository from "../idb/repositories/primaryBehaviourRepository";

export default {
  components: {
    NavHeader,
  },
  data() {
    return {
      title: this.$englishPreferred ? "FiNN" : "FiNN",
    };
  },

  methods: {
    async directToNewCount() {
      let siteCount = await siteRepository.getSitesCount();
      let speciesCount = await specieRepository.getSpeciesCount();
      let primaryBehaviourCount =
        await primaryBehaviourRepository.getPrimaryBehaviourCount();
      if (
        siteCount != null &&
        siteCount > 0 &&
        speciesCount != null &&
        speciesCount > 0 &&
        primaryBehaviourCount != null &&
        primaryBehaviourCount > 0
      ) {
        this.$router.push({ path: "/finn/taelling/ny" });
      } else {
        this.reloadLocalAppData();
      }
    },
    async directToCompletedCount() {
      let siteCount = await siteRepository.getSitesCount();
      let speciesCount = await specieRepository.getSpeciesCount();
      let primaryBehaviourCount =
        await primaryBehaviourRepository.getPrimaryBehaviourCount();
      if (
        siteCount != null &&
        siteCount > 0 &&
        speciesCount != null &&
        speciesCount > 0 &&
        primaryBehaviourCount != null &&
        primaryBehaviourCount > 0
      ) {
        this.$router.push({ path: "/finn/taelling/indtast" });
      } else {
        this.reloadLocalAppData();
      }
    },
    reloadLocalAppData() {
      console.log("No sites found, local data seems out of sync..");
      // set app out of sync, by removing cookie, then reload the page so the sync will run
      $cookies.remove("synched");
      location.reload();
    },
  },
};
</script>

<style scoped>
.finn-home-page {
  background: radial-gradient(
      circle at 95% 0,
      rgb(255 136 0 / 14%),
      transparent 19rem
    ),
    linear-gradient(180deg, #fffaf3 0%, #f2f7f7 100%);
  min-height: 100vh;
  min-height: 100dvh;
}

:deep(#navbar) {
  margin-bottom: 0 !important;
}

.finn-home-content {
  margin: 0 auto;
  max-width: 760px;
  padding: 1rem 0.8rem 2rem;
}

.finn-intro-card {
  background: linear-gradient(135deg, #ffffff 0%, #fff7eb 100%);
  border: 1px solid rgb(255 136 0 / 16%);
  border-radius: 1.25rem;
  box-shadow: 0 12px 34px rgb(91 61 24 / 11%);
  display: grid;
  gap: 0.8rem;
  grid-template-columns: 3.25rem minmax(0, 1fr);
  margin-bottom: 1rem;
  overflow: hidden;
  padding: 1.05rem 1rem 0.9rem;
  position: relative;
}

.finn-intro-card::after {
  background: linear-gradient(90deg, #e97700, #ffad35);
  bottom: 0;
  content: "";
  height: 4px;
  left: 0;
  position: absolute;
  right: 0;
}

.finn-intro-icon {
  align-items: center;
  background: linear-gradient(135deg, #e77800, #ff9b1c);
  border-radius: 1rem;
  box-shadow: 0 7px 16px rgb(255 136 0 / 22%);
  color: #fff;
  display: flex;
  height: 3.25rem;
  justify-content: center;
  width: 3.25rem;
}

.finn-intro-icon .material-icons {
  font-size: 1.75rem;
}

.finn-kicker {
  color: #cf6800;
  display: block;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  margin-bottom: 0.1rem;
  text-transform: uppercase;
}

.finn-intro-copy h1 {
  color: #173f54;
  font-size: 1.35rem;
  font-weight: 800;
  letter-spacing: -0.025em;
  margin: 0 0 0.25rem;
}

.finn-intro-copy p {
  color: #5d6f78;
  font-size: 0.84rem;
  line-height: 1.4;
  margin: 0 0 0.6rem;
}

.finn-project-link {
  align-items: center;
  color: #bd6000;
  display: inline-flex;
  font-size: 0.82rem;
  font-weight: 800;
  gap: 0.3rem;
  text-decoration: none;
}

.finn-project-link .material-icons {
  font-size: 1rem;
}

.finn-support-badge {
  background: rgb(255 255 255 / 88%);
  border: 1px solid rgb(255 136 0 / 16%);
  border-radius: 999px;
  color: #826441;
  font-size: 0.62rem;
  font-weight: 750;
  grid-column: 1 / -1;
  justify-self: start;
  padding: 0.3rem 0.55rem;
}

.finn-menu {
  display: grid;
  gap: 0.7rem;
}

.finn-menu-button {
  align-items: center;
  background: rgb(255 255 255 / 96%);
  border: 1px solid rgb(230 119 0 / 36%);
  border-radius: 0.9rem;
  box-shadow: 0 4px 12px rgb(105 72 30 / 8%);
  color: #b85d00;
  display: grid;
  font-size: 0.96rem;
  font-weight: 700;
  gap: 0.65rem;
  grid-template-columns: 2.35rem minmax(0, 1fr) 1.25rem;
  min-height: 3.65rem;
  padding: 0.55rem 0.85rem;
  text-decoration: none;
  transition: box-shadow 160ms ease, transform 160ms ease;
  width: 100%;
}

.finn-menu-button.is-primary {
  background: linear-gradient(135deg, #ed7d00, #ff9514);
  border-color: transparent;
  box-shadow: 0 5px 14px rgb(230 119 0 / 19%);
  color: #fff;
}

.finn-menu-button:hover,
.finn-menu-button:focus-visible {
  box-shadow: 0 8px 19px rgb(112 73 28 / 17%);
  color: #a75500;
  transform: translateY(-2px);
}

.finn-menu-button.is-primary:hover,
.finn-menu-button.is-primary:focus-visible {
  color: #fff;
}

.finn-menu-icon {
  align-items: center;
  background: rgb(255 136 0 / 10%);
  border-radius: 0.65rem;
  display: flex;
  height: 2.35rem;
  justify-content: center;
  width: 2.35rem;
}

.is-primary .finn-menu-icon {
  background: rgb(255 255 255 / 20%);
}

.finn-menu-icon .material-icons {
  font-size: 1.35rem;
}

.finn-menu-label {
  line-height: 1.22;
  text-align: center;
}

.finn-menu-arrow {
  font-size: 1.25rem;
  opacity: 0.7;
}

@media (max-width: 420px) {
  .finn-home-content {
    padding-left: 0.6rem;
    padding-right: 0.6rem;
  }

  .finn-intro-card {
    grid-template-columns: 2.8rem minmax(0, 1fr);
    padding-left: 0.8rem;
    padding-right: 0.8rem;
  }

  .finn-intro-icon {
    border-radius: 0.85rem;
    height: 2.8rem;
    width: 2.8rem;
  }

  .finn-menu-button {
    font-size: 0.88rem;
    gap: 0.5rem;
    grid-template-columns: 2.15rem minmax(0, 1fr) 1rem;
    padding-left: 0.65rem;
    padding-right: 0.65rem;
  }

  .finn-menu-icon {
    height: 2.15rem;
    width: 2.15rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .finn-menu-button {
    transition: none;
  }

  .finn-menu-button:hover,
  .finn-menu-button:focus-visible {
    transform: none;
  }
}
</style>
